<template>
  <div>
    <div>Doc 维护中 敬请期待</div>
  </div>
</template>
<script>
import { onMounted, onUnmounted, reactive, getCurrentInstance } from 'vue'
import { useRouter } from 'vue-router'
import { useStore } from 'vuex'
export default {
  setup() {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const router = useRouter()
    const store = useStore()
    const obj = reactive({
      windowWidth: 0,
      windowHeight: 0,
    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
    })

    return {
      obj,
    }

  }
}
</script>
<style scoped></style>